module.exports = __webpack_public_path__ + "static/img/apex-small.870b13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/discord/apex-small.png
// module id = azDS
// module chunks = 35